import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment-timezone';
import { Subject, debounceTime, filter, forkJoin } from 'rxjs';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { BillingService } from 'src/app/services/core/billing/billing.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { CsvService } from 'src/app/services/core/csv-service/csv.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { ServiceAreasService } from 'src/app/services/core/service-areas-service/service-areas.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { timeZone } from 'src/app/utils/utils.common';
@UntilDestroy()

@Component({
  selector: 'app-billing-list',
  templateUrl: './billing-list.component.html',
  styleUrls: ['./billing-list.component.css']
})
export class BillingListComponent implements OnInit {
  search: any;
  trips: any = [];
  filterdataList: any = [];
  selectedTrips: any = [];
  spacetypes: any;
  serviceAreas: any;
  fundingSources: any;
  preSpacetypes: any = {};
  preServiceAreas: any = {};
  preAppointmentType: any = {};
  preCompanies: any = {};
  preLevelOfService: any = {};
  preFundingSource: any = {};
  currentPage = 1;
  totalResults = 0;
  totalPages = 0;
  numberOfRecords = NUMBER_OF_RECORDS;
  todayDate: any = [];
  selectedServiceArea: any = '';
  selectedPaymentStatus: any = '';
  selectedPaymentType: any = '';
  selectedDropdownIndex: any;
  toggleActionButtons = false;
  isDropdownOpen = false;
  user: any;
  timeZone: any = timeZone;
  userPermission = UserPermission;
  tripId: any;
  memberNotesObj: any;
  tripTrailId: any;
  payModalObj: any;
  payRelation: any;
  private searchSubject = new Subject<string>();

  constructor(
    private sharedDataService: SharedDataService,
    private serviceArea: ServiceAreasService,
    private credentialService: CredentialService,
    private levelOfService: LosService,
    private appointmentService: AppointmentTypeService,
    private spaceTypeService: SpaceTypeService,
    private billingService: BillingService,
    private csvService: CsvService,
    public permissionService: PermissionService,
    private fundingSourceService: FundingSourceService
  ) {
  }

  ngOnInit(): void {
    this.getUser();
    this.getFundingSources();
    this.initializeSearch();
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
        if (this.user.timeZone) {
          this.timeZone = this.user.timeZone;
        }
        this.todayDate = [
          moment().tz(this.timeZone).startOf("day"),
          moment().tz(this.timeZone).endOf("day"),
        ];
        this.loadInitialData();
      }
    })
  }

  loadInitialData() {
    const queryparams = {
      limit: 9999,
      isActive: 'true'
    }
    forkJoin({
      companies: this.credentialService.getPicker(queryparams),
      levelOfService: this.levelOfService.getPicker(queryparams),
      appointments: this.appointmentService.getPicker(queryparams),
      spaceTypes: this.spaceTypeService.getPicker(queryparams),
      serviceAreas: this.serviceArea.getPicker(queryparams)
    }).pipe(untilDestroyed(this))
      .subscribe(({ companies, levelOfService, appointments, spaceTypes, serviceAreas }: any) => {

        //  Companies
        if (companies?.results?.length) {
          this.preCompanies = companies.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Level of Service
        if (levelOfService?.results?.length) {
          this.preLevelOfService = levelOfService.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Appointments
        if (appointments?.results?.length) {
          this.preAppointmentType = appointments.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Space Types
        if (spaceTypes?.results?.length) {
          this.spacetypes = spaceTypes.results;
          this.preSpacetypes = this.spacetypes.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  serviceAreas
        if (serviceAreas?.results?.length) {
          this.serviceAreas = serviceAreas.results;
          this.preServiceAreas = serviceAreas.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        //  Trips
        this.getAllTrips(this.currentPage);
      });
  }

  getAllTrips(page: any) {
    this.clear();
    let queryparams: any = {
      limit: this.numberOfRecords,
      page,
      status: ['completed', 'cancelled'],
      time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
      sortBy: 'member:asc',
      fundingsource: this.user.fundingsource.id
    };
    if (this.selectedServiceArea) {
      queryparams.serviceArea = this.selectedServiceArea;
    }
    if (this.selectedPaymentStatus) {
      queryparams.payment = this.selectedPaymentStatus;
    }

    if (this.selectedPaymentType) {
      queryparams.paymentType = this.selectedPaymentType;
    }
    if (this.search) {
      queryparams.search = this.search.trim();
    }
    this.billingService.getFundingSourceBillingTrips(queryparams)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results) {
          this.trips = data.results.map((trip: any) => ({
            ...trip,
            onway: trip.events?.find((e: any) => e.status === 'onway'),
            arrived: trip.events?.find((e: any) => e.status === 'arrived'),
            inProgress: trip.events?.find((e: any) => e.status === 'in_progress'),
            completed: trip.events?.find((e: any) => e.status === 'completed')
          }));
          this.filterdataList = this.trips;
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      });
  }

  getFundingSources() {
    const queryParams = {
      limit: 9999,
      isActive: true
    }
    this.fundingSourceService
      .getPicker(queryParams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.fundingSources = data.results;
          this.preFundingSource = this.fundingSources.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      });
  }

  onSelectTrip(trip: any) {
    const index = this.selectedTrips.findIndex((t: any) => t.id === trip.id);
    if (index > -1) {
      trip.isSelected = false;
      this.selectedTrips.splice(index, 1);
    } else {
      trip.isSelected = true;
      this.selectedTrips.push(trip);
    }
  }

  onSelectAllTrips(event: any) {
    const checked = event.target.checked;
    this.filterdataList.forEach((trip: any) => trip.isSelected = checked);
    this.selectedTrips = checked ? [...this.filterdataList] : [];
  }

  getSelectedTrips() {
    return this.trips.filter((trip: any) => trip.isSelected);
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getAllTrips(page);
  }

  onDateChange(event: any) {
    this.todayDate = [
      event[0],
      event[1].endOf("day"),
    ];
    this.currentPage = 1;
    this.getAllTrips(this.currentPage);
  }

  onServiceAreaChange() {
    this.getAllTrips(this.currentPage);
  }

  onPaymentStatusChange() {
    this.currentPage = 1;
    this.getAllTrips(this.currentPage);
  }

  onPaymentTypeChange() {
    this.currentPage = 1;
    this.getAllTrips(this.currentPage);
  }

  onSearchInput() {
    this.searchSubject.next(this.search);
  }

  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500),
        filter((search: any) => !search || search.length >= 3)
      )
      .subscribe(() => {
        this.currentPage = 1;
        this.getAllTrips(this.currentPage);
      });
  }

  clear() {
    this.trips = [];
    this.selectedTrips = [];
  }

  showActionButtons(idx: any) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt: any) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
  }

  closeFilterDropDown(evt: any) {
    this.isDropdownOpen = false;
  }

  toggleDropdown(event: MouseEvent) {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  opendetailModal(trip: any) {
    this.tripId = trip.id;
  }

  openNotesModal(memberNotes: any) {
    this.memberNotesObj = memberNotes;
  }

  openTripTrails(trip: any) {
    this.tripTrailId = trip.id;
  }

  openPayModal(trip: any) {
    this.payModalObj = trip;
    this.payRelation = { relationType: 'fundingsource', fundingSource: trip.fundingsource, billing: trip.id, trip: trip.trip };
  }

  onClosePayModal(evt: any) {
    this.payModalObj = null;
    this.payRelation = null;
    if (evt) {
      // the billing is now settled — pull the refreshed payment state
      this.getAllTrips(this.currentPage);
    }
  }

  tripDetailFile() {
    const selectedTrip = this.selectedTrips.length ? this.getSelectedTrips() : this.trips;
    this.csvService.generateTripItineraryReport(selectedTrip, this.todayDate, this.timeZone, this.preLevelOfService, this.preSpacetypes, this.preServiceAreas);
  }

  downloadRawReport() {
    const selectedTrips = this.getSelectedTrips();
    const filterTrips = this.selectedTrips.length
      ? this.trips.filter((trip: any) => selectedTrips.some((selected: any) => selected.id === trip.id))
      : this.trips;
    const queryparams = {
      selectedIds: filterTrips.map((trip: any) => trip.id),
      time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
    }
    this.billingService.getFsReportTrips(queryparams)
      .pipe(untilDestroyed(this))
      .subscribe((trips: any) => {
        if (trips && trips.length) {
          this.csvService.generateRawTripReport(trips, this.todayDate, this.timeZone);
        }
      });
  }

}
